"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_cpu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "51b3bf0f-3906-4743-9b15-f8fd5ed4502a",
    "data-name": "Ebene 47",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1em",
    height: "1em",
    viewBox: "0 0 192 192"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "0c9206b7-525e-4d11-905a-a5fcd8fc6dc0",
    x1: 52.59,
    y1: 139.41,
    x2: 67.41,
    y2: 154.24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "8e1563dd-efa3-46d0-b313-734a84b076ad",
    x1: 76.59,
    y1: 139.41,
    x2: 91.41,
    y2: 154.24,
    xlinkHref: "#0c9206b7-525e-4d11-905a-a5fcd8fc6dc0"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "61d7e718-c61c-4142-8745-bf561aef922c",
    x1: 28.59,
    y1: 139.41,
    x2: 43.41,
    y2: 154.24,
    xlinkHref: "#0c9206b7-525e-4d11-905a-a5fcd8fc6dc0"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "86fa9bce-a638-4d69-bba7-1d1fd896453f",
    x1: 148.59,
    y1: 139.41,
    x2: 163.41,
    y2: 154.24,
    xlinkHref: "#0c9206b7-525e-4d11-905a-a5fcd8fc6dc0"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "12193d58-2cbd-4fa2-8eb3-d9543df79169",
    x1: 100.59,
    y1: 139.41,
    x2: 115.41,
    y2: 154.24,
    xlinkHref: "#0c9206b7-525e-4d11-905a-a5fcd8fc6dc0"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "584bbbab-1f5b-44f8-bdec-a9a35ad9145e",
    x1: 124.59,
    y1: 139.41,
    x2: 139.41,
    y2: 154.24,
    xlinkHref: "#0c9206b7-525e-4d11-905a-a5fcd8fc6dc0"
  })), /*#__PURE__*/React.createElement("title", null, "cpu-hi"), /*#__PURE__*/React.createElement("path", {
    d: "M84,64a4,4,0,0,1-4-4V36a4,4,0,0,1,8,0V60A4,4,0,0,1,84,64Z",
    transform: "translate(0 0)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108,64a4,4,0,0,1-4-4V36a4,4,0,1,1,8,0V60A4,4,0,0,1,108,64Z",
    transform: "translate(0 0)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132,64a4,4,0,0,1-4-4V36a4,4,0,0,1,8,0V60A4,4,0,0,1,132,64Z",
    transform: "translate(0 0)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156,64a4,4,0,0,1-4-4V36a4,4,0,0,1,8,0V60A4,4,0,0,1,156,64Z",
    transform: "translate(0 0)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60,64a4,4,0,0,1-4-4V36a4,4,0,1,1,8,0V60A4,4,0,0,1,60,64Z",
    transform: "translate(0 0)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36,64a4,4,0,0,1-4-4V36a4,4,0,0,1,8,0V60A4,4,0,0,1,36,64Z",
    transform: "translate(0 0)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84,160a4,4,0,0,1-4-4V132a4,4,0,0,1,8,0v24A4,4,0,0,1,84,160Z",
    transform: "translate(0 0)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108,160a4,4,0,0,1-4-4V132a4,4,0,0,1,8,0v24A4,4,0,0,1,108,160Z",
    transform: "translate(0 0)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132,160a4,4,0,0,1-4-4V132a4,4,0,0,1,8,0v24A4,4,0,0,1,132,160Z",
    transform: "translate(0 0)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156,160a4,4,0,0,1-4-4V132a4,4,0,0,1,8,0v24A4,4,0,0,1,156,160Z",
    transform: "translate(0 0)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60,160a4,4,0,0,1-4-4V132a4,4,0,1,1,8,0v24A4,4,0,0,1,60,160Z",
    transform: "translate(0 0)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36,160a4,4,0,0,1-4-4V132a4,4,0,0,1,8,0v24A4,4,0,0,1,36,160Z",
    transform: "translate(0 0)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.12
  }, /*#__PURE__*/React.createElement("path", {
    d: "M84,64a4,4,0,0,1-4-4V36a4,4,0,0,1,8,0V60A4,4,0,0,1,84,64Z",
    transform: "translate(0 0)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108,64a4,4,0,0,1-4-4V36a4,4,0,1,1,8,0V60A4,4,0,0,1,108,64Z",
    transform: "translate(0 0)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132,64a4,4,0,0,1-4-4V36a4,4,0,0,1,8,0V60A4,4,0,0,1,132,64Z",
    transform: "translate(0 0)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156,64a4,4,0,0,1-4-4V36a4,4,0,0,1,8,0V60A4,4,0,0,1,156,64Z",
    transform: "translate(0 0)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60,64a4,4,0,0,1-4-4V36a4,4,0,1,1,8,0V60A4,4,0,0,1,60,64Z",
    transform: "translate(0 0)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36,64a4,4,0,0,1-4-4V36a4,4,0,0,1,8,0V60A4,4,0,0,1,36,64Z",
    transform: "translate(0 0)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84,160a4,4,0,0,1-4-4V132a4,4,0,0,1,8,0v24A4,4,0,0,1,84,160Z",
    transform: "translate(0 0)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108,160a4,4,0,0,1-4-4V132a4,4,0,0,1,8,0v24A4,4,0,0,1,108,160Z",
    transform: "translate(0 0)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132,160a4,4,0,0,1-4-4V132a4,4,0,0,1,8,0v24A4,4,0,0,1,132,160Z",
    transform: "translate(0 0)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156,160a4,4,0,0,1-4-4V132a4,4,0,0,1,8,0v24A4,4,0,0,1,156,160Z",
    transform: "translate(0 0)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60,160a4,4,0,0,1-4-4V132a4,4,0,1,1,8,0v24A4,4,0,0,1,60,160Z",
    transform: "translate(0 0)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36,160a4,4,0,0,1-4-4V132a4,4,0,0,1,8,0v24A4,4,0,0,1,36,160Z",
    transform: "translate(0 0)",
    fill: "#333"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 192,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160,56H32a8,8,0,0,0-8,8v64a8,8,0,0,0,8,8H160a8,8,0,0,0,8-8V64A8,8,0,0,0,160,56Z",
    transform: "translate(0 0)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160,134H32a8,8,0,0,1-8-8v2a8,8,0,0,0,8,8H160a8,8,0,0,0,8-8v-2A8,8,0,0,1,160,134Z",
    transform: "translate(0 0)",
    fill: "#333",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.06
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60,158a4,4,0,0,1-4-4v2a4,4,0,1,0,8,0v-2A4,4,0,0,1,60,158Z",
    transform: "translate(0 0)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84,158a4,4,0,0,1-4-4v2a4,4,0,0,0,8,0v-2A4,4,0,0,1,84,158Z",
    transform: "translate(0 0)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36,158a4,4,0,0,1-4-4v2a4,4,0,0,0,8,0v-2A4,4,0,0,1,36,158Z",
    transform: "translate(0 0)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156,158a4,4,0,0,1-4-4v2a4,4,0,0,0,8,0v-2A4,4,0,0,1,156,158Z",
    transform: "translate(0 0)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108,158a4,4,0,0,1-4-4v2a4,4,0,0,0,8,0v-2A4,4,0,0,1,108,158Z",
    transform: "translate(0 0)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132,158a4,4,0,0,1-4-4v2a4,4,0,0,0,8,0v-2A4,4,0,0,1,132,158Z",
    transform: "translate(0 0)",
    fill: "#333"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M64,136v20a4,4,0,1,1-8,0V136Z",
    transform: "translate(0 0)",
    opacity: 0.2,
    fill: "url(#0c9206b7-525e-4d11-905a-a5fcd8fc6dc0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80,136v20a4,4,0,0,0,8,0V136Z",
    transform: "translate(0 0)",
    opacity: 0.2,
    fill: "url(#8e1563dd-efa3-46d0-b313-734a84b076ad)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32,136v20a4,4,0,0,0,8,0V136Z",
    transform: "translate(0 0)",
    opacity: 0.2,
    fill: "url(#61d7e718-c61c-4142-8745-bf561aef922c)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152,156a4,4,0,0,0,8,0V136h-8Z",
    transform: "translate(0 0)",
    opacity: 0.2,
    fill: "url(#86fa9bce-a638-4d69-bba7-1d1fd896453f)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104,136v20a4,4,0,0,0,8,0V136Z",
    transform: "translate(0 0)",
    opacity: 0.2,
    fill: "url(#12193d58-2cbd-4fa2-8eb3-d9543df79169)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128,136v20a4,4,0,0,0,8,0V136Z",
    transform: "translate(0 0)",
    opacity: 0.2,
    fill: "url(#584bbbab-1f5b-44f8-bdec-a9a35ad9145e)"
  }));
}

var _default = ic_cpu;
exports.default = _default;